module.exports = __webpack_public_path__ + "img/bc-liberals-logo.efe14966.jpg";